import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.962 9.725C19.94 9.648 17.666 2 10 2S.06 9.648.038 9.725c-.05.18-.05.37 0 .55C.06 10.352 2.334 18 10 18s9.94-7.648 9.962-7.725c.05-.18.05-.37 0-.55zM10 16c-5.467 0-7.512-4.772-7.948-6C2.488 8.772 4.532 4 10 4c5.47 0 7.514 4.776 7.948 6-.435 1.228-2.48 6-7.948 6zm0-4c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-6c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z"
});

var SvgViewMajorMonotone = function SvgViewMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgViewMajorMonotone as S };